import { TreeNode } from "./types";

export const treeData: TreeNode[] = [
                                      {
                                        "id": "c10000000006",
                                        "label": "Asia-Pacific",
                                        "children": [
                                          {
                                            "id": "c22000000013",
                                            "label": "Australia and Oceania",
                                            "children": [
                                              {
                                                "id": "c25000100035",
                                                "label": "Other pacific island nations",
                                                "children": [
                                                  {
                                                    "id": "c10000001039",
                                                    "label": "Guam"
                                                  },
                                                  {
                                                    "id": "c10000001046",
                                                    "label": "Kiribati"
                                                  },
                                                  {
                                                    "id": "c25000100008",
                                                    "label": "Marshall Islands"
                                                  },
                                                  {
                                                    "id": "c25000100010",
                                                    "label": "Nauru"
                                                  },
                                                  {
                                                    "id": "c25000100012",
                                                    "label": "Palau"
                                                  },
                                                  {
                                                    "id": "c25000100016",
                                                    "label": "Samoa"
                                                  },
                                                  {
                                                    "id": "c25000100018",
                                                    "label": "Solomon Islands"
                                                  },
                                                  {
                                                    "id": "c25000100023",
                                                    "label": "Tonga"
                                                  },
                                                  {
                                                    "id": "c25000100025",
                                                    "label": "Tuvalu"
                                                  },
                                                  {
                                                    "id": "c25000100026",
                                                    "label": "Vanuatu"
                                                  }
                                                ]
                                              },
                                              {
                                                "id": "c00000000010",
                                                "label": "Australia"
                                              },
                                              {
                                                "id": "c25000100003",
                                                "label": "Fiji"
                                              },
                                              {
                                                "id": "c00000000043",
                                                "label": "New Zealand"
                                              },
                                              {
                                                "id": "c10000001069",
                                                "label": "Papua New Guinea"
                                              }
                                            ]
                                          },
                                          {
                                            "id": "c25000100033",
                                            "label": "East-Asia",
                                            "children": [
                                              {
                                                "id": "c00000000021",
                                                "label": "Hong Kong"
                                              },
                                              {
                                                "id": "c00000000029",
                                                "label": "Japan"
                                              },
                                              {
                                                "id": "c10000001061",
                                                "label": "Mongolia"
                                              },
                                              {
                                                "id": "c00000000034",
                                                "label": "North Korea"
                                              },
                                              {
                                                "id": "c10000000033",
                                                "label": "South Korea"
                                              },
                                              {
                                                "id": "c00000000066",
                                                "label": "Taiwan"
                                              }
                                            ]
                                          },
                                          {
                                            "id": "c25000100027",
                                            "label": "South Asia (excl. India)",
                                            "children": [
                                              {
                                                "id": "c10000001013",
                                                "label": "Bangladesh"
                                              },
                                              {
                                                "id": "c10000001017",
                                                "label": "Bhutan"
                                              },
                                              {
                                                "id": "c10000001057",
                                                "label": "Maldives"
                                              },
                                              {
                                                "id": "c25000100011",
                                                "label": "Nepal"
                                              },
                                              {
                                                "id": "c00000000048",
                                                "label": "Pakistan"
                                              },
                                              {
                                                "id": "c25000100020",
                                                "label": "Sri Lanka"
                                              }
                                            ]
                                          },
                                          {
                                            "id": "c25000100028",
                                            "label": "Southeast Asia (ASEAN)",
                                            "children": [
                                              {
                                                "id": "c10000001019",
                                                "label": "Brunei"
                                              },
                                              {
                                                "id": "c10000001021",
                                                "label": "Cambodia"
                                              },
                                              {
                                                "id": "c00000000023",
                                                "label": "Indonesia"
                                              },
                                              {
                                                "id": "c10000001048",
                                                "label": "Laos"
                                              },
                                              {
                                                "id": "c00000000041",
                                                "label": "Malaysia"
                                              },
                                              {
                                                "id": "c25000100009",
                                                "label": "Myanmar"
                                              },
                                              {
                                                "id": "c00000000049",
                                                "label": "Philippines"
                                              },
                                              {
                                                "id": "c00000000059",
                                                "label": "Singapore"
                                              },
                                              {
                                                "id": "c00000000067",
                                                "label": "Thailand"
                                              },
                                              {
                                                "id": "c25000100022",
                                                "label": "Timor-Leste"
                                              },
                                              {
                                                "id": "c10000001084",
                                                "label": "Vietnam"
                                              }
                                            ]
                                          },
                                          {
                                            "id": "c00000000047",
                                            "label": "China"
                                          },
                                          {
                                            "id": "c00000000022",
                                            "label": "India"
                                          }
                                        ]
                                      },
                                      {
                                        "id": "c10000000004",
                                        "label": "CIS countries",
                                        "children": [
                                          {
                                            "id": "c10000001008",
                                            "label": "Armenia"
                                          },
                                          {
                                            "id": "c10000001010",
                                            "label": "Azerbaijan"
                                          },
                                          {
                                            "id": "c00000000076",
                                            "label": "Belarus"
                                          },
                                          {
                                            "id": "c10000001000",
                                            "label": "Kazakhstan"
                                          },
                                          {
                                            "id": "c10000001047",
                                            "label": "Kyrgyzstan"
                                          },
                                          {
                                            "id": "c10000001003",
                                            "label": "Moldova"
                                          },
                                          {
                                            "id": "c00000000054",
                                            "label": "Russia"
                                          },
                                          {
                                            "id": "c00000000065",
                                            "label": "Tajikistan"
                                          },
                                          {
                                            "id": "c10000001080",
                                            "label": "Turkmenistan"
                                          },
                                          {
                                            "id": "c10000001083",
                                            "label": "Uzbekistan"
                                          }
                                        ]
                                      },
                                      {
                                        "id": "c00000000001",
                                        "label": "Europe (incl. EU and EFTA)",
                                        "children": [
                                          {
                                            "id": "c10000000024",
                                            "label": "European Union",
                                            "children": [
                                              {
                                                "id": "c00000000046",
                                                "label": "Austria"
                                              },
                                              {
                                                "id": "c00000000011",
                                                "label": "Belgium"
                                              },
                                              {
                                                "id": "c00000000014",
                                                "label": "Bulgaria"
                                              },
                                              {
                                                "id": "c00000000035",
                                                "label": "Croatia"
                                              },
                                              {
                                                "id": "c00000000077",
                                                "label": "Cyprus"
                                              },
                                              {
                                                "id": "c00000000068",
                                                "label": "Czech Republic"
                                              },
                                              {
                                                "id": "c00000000015",
                                                "label": "Denmark"
                                              },
                                              {
                                                "id": "c10000000034",
                                                "label": "Estonia"
                                              },
                                              {
                                                "id": "c00000000018",
                                                "label": "Finland"
                                              },
                                              {
                                                "id": "c00000000019",
                                                "label": "France"
                                              },
                                              {
                                                "id": "c00000000016",
                                                "label": "Germany"
                                              },
                                              {
                                                "id": "c00000000020",
                                                "label": "Greece"
                                              },
                                              {
                                                "id": "c00000000072",
                                                "label": "Hungary"
                                              },
                                              {
                                                "id": "c00000000026",
                                                "label": "Ireland"
                                              },
                                              {
                                                "id": "c00000000028",
                                                "label": "Italy"
                                              },
                                              {
                                                "id": "c10000000021",
                                                "label": "Latvia"
                                              },
                                              {
                                                "id": "c00000000038",
                                                "label": "Lithuania"
                                              },
                                              {
                                                "id": "c00000000039",
                                                "label": "Luxembourg"
                                              },
                                              {
                                                "id": "c25000100007",
                                                "label": "Malta"
                                              },
                                              {
                                                "id": "c00000000044",
                                                "label": "Netherlands"
                                              },
                                              {
                                                "id": "c00000000050",
                                                "label": "Poland"
                                              },
                                              {
                                                "id": "c00000000051",
                                                "label": "Portugal"
                                              },
                                              {
                                                "id": "c00000000053",
                                                "label": "Romania"
                                              },
                                              {
                                                "id": "c00000000060",
                                                "label": "Slovakia"
                                              },
                                              {
                                                "id": "c00000000061",
                                                "label": "Slovenia"
                                              },
                                              {
                                                "id": "c00000000062",
                                                "label": "Spain"
                                              },
                                              {
                                                "id": "c00000000056",
                                                "label": "Sweden"
                                              }
                                            ]
                                          },
                                          {
                                            "id": "c25000100031",
                                            "label": "Other European countries",
                                            "children": [
                                              {
                                                "id": "c10000001004",
                                                "label": "Albania"
                                              },
                                              {
                                                "id": "c10000000026",
                                                "label": "Andorra"
                                              },
                                              {
                                                "id": "c00000000076",
                                                "label": "Belarus"
                                              },
                                              {
                                                "id": "c00000000012",
                                                "label": "Bosnia and Herzegovina"
                                              },
                                              {
                                                "id": "c10000001037",
                                                "label": "Georgia"
                                              },
                                              {
                                                "id": "c10000001043",
                                                "label": "Iceland"
                                              },
                                              {
                                                "id": "c25000100006",
                                                "label": "Kosovo"
                                              },
                                              {
                                                "id": "c10000000028",
                                                "label": "Liechtenstein"
                                              },
                                              {
                                                "id": "c10000001003",
                                                "label": "Moldova"
                                              },
                                              {
                                                "id": "c10000001002",
                                                "label": "Montenegro"
                                              },
                                              {
                                                "id": "c00000000040",
                                                "label": "North Macedonia"
                                              },
                                              {
                                                "id": "c00000000045",
                                                "label": "Norway"
                                              },
                                              {
                                                "id": "c10000001001",
                                                "label": "Serbia"
                                              },
                                              {
                                                "id": "c00000000057",
                                                "label": "Switzerland"
                                              },
                                              {
                                                "id": "c00000000069",
                                                "label": "Turkey"
                                              },
                                              {
                                                "id": "c00000000071",
                                                "label": "Ukraine"
                                              },
                                              {
                                                "id": "c10000001082",
                                                "label": "United Kingdom"
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "id": "c00000000004",
                                        "label": "Middle East and North Africa",
                                        "children": [
                                          {
                                            "id": "c25000100030",
                                            "label": "Gulf Cooperation Council (GCC)",
                                            "children": [
                                              {
                                                "id": "c10000001012",
                                                "label": "Bahrain"
                                              },
                                              {
                                                "id": "c00000000037",
                                                "label": "Kuwait"
                                              },
                                              {
                                                "id": "c10000001068",
                                                "label": "Oman"
                                              },
                                              {
                                                "id": "c00000000032",
                                                "label": "Qatar"
                                              },
                                              {
                                                "id": "c00000000055",
                                                "label": "Saudi Arabia"
                                              },
                                              {
                                                "id": "c00000000070",
                                                "label": "United Arab Emirates"
                                              }
                                            ]
                                          },
                                          {
                                            "id": "c10000000027",
                                            "label": "Algeria"
                                          },
                                          {
                                            "id": "c00000000008",
                                            "label": "Egypt"
                                          },
                                          {
                                            "id": "c00000000025",
                                            "label": "Iran"
                                          },
                                          {
                                            "id": "c00000000024",
                                            "label": "Iraq"
                                          },
                                          {
                                            "id": "c00000000027",
                                            "label": "Israel"
                                          },
                                          {
                                            "id": "c00000000030",
                                            "label": "Jordan"
                                          },
                                          {
                                            "id": "c10000001050",
                                            "label": "Lebanon"
                                          },
                                          {
                                            "id": "c10000001052",
                                            "label": "Libya"
                                          },
                                          {
                                            "id": "c10000001059",
                                            "label": "Mauritania"
                                          },
                                          {
                                            "id": "c10000000025",
                                            "label": "Morocco"
                                          },
                                          {
                                            "id": "c00000000064",
                                            "label": "Syria"
                                          },
                                          {
                                            "id": "c10000001079",
                                            "label": "Tunisia"
                                          },
                                          {
                                            "id": "c00000000069",
                                            "label": "Turkey"
                                          },
                                          {
                                            "id": "c10000001087",
                                            "label": "Yemen"
                                          }
                                        ]
                                      },
                                      {
                                        "id": "c10000000009",
                                        "label": "South-America (Continent)",
                                        "children": [
                                          {
                                            "id": "c10000000039",
                                            "label": "Latin-America (excl. Brasil)",
                                            "children": [
                                              {
                                                "id": "c25000100029",
                                                "label": "Central America and Caribbean",
                                                "children": [
                                                  {
                                                    "id": "c10000001007",
                                                    "label": "Antigua and Barbuda"
                                                  },
                                                  {
                                                    "id": "c10000001009",
                                                    "label": "Aruba"
                                                  },
                                                  {
                                                    "id": "c10000001011",
                                                    "label": "Bahamas"
                                                  },
                                                  {
                                                    "id": "c10000001014",
                                                    "label": "Barbados"
                                                  },
                                                  {
                                                    "id": "c10000000037",
                                                    "label": "Belize"
                                                  },
                                                  {
                                                    "id": "c10000000018",
                                                    "label": "Costa Rica"
                                                  },
                                                  {
                                                    "id": "c00000000036",
                                                    "label": "Cuba"
                                                  },
                                                  {
                                                    "id": "c10000000019",
                                                    "label": "Dominica"
                                                  },
                                                  {
                                                    "id": "c10000000032",
                                                    "label": "Dominican Republic"
                                                  },
                                                  {
                                                    "id": "c10000000015",
                                                    "label": "El Salvador"
                                                  },
                                                  {
                                                    "id": "c10000001033",
                                                    "label": "Falkland Islands"
                                                  },
                                                  {
                                                    "id": "c25000100004",
                                                    "label": "Grenada"
                                                  },
                                                  {
                                                    "id": "c10000000016",
                                                    "label": "Guatemala"
                                                  },
                                                  {
                                                    "id": "c10000001041",
                                                    "label": "Guyana"
                                                  },
                                                  {
                                                    "id": "c10000001042",
                                                    "label": "Haiti"
                                                  },
                                                  {
                                                    "id": "c10000000017",
                                                    "label": "Honduras"
                                                  },
                                                  {
                                                    "id": "c10000001044",
                                                    "label": "Jamaica"
                                                  },
                                                  {
                                                    "id": "c10000001062",
                                                    "label": "Montserrat"
                                                  },
                                                  {
                                                    "id": "c10000000038",
                                                    "label": "Nicaragua"
                                                  },
                                                  {
                                                    "id": "c10000000014",
                                                    "label": "Panama"
                                                  },
                                                  {
                                                    "id": "c10000000031",
                                                    "label": "Puerto Rico"
                                                  },
                                                  {
                                                    "id": "c25000100013",
                                                    "label": "St. Kitts and Nevis"
                                                  },
                                                  {
                                                    "id": "c25000100014",
                                                    "label": "St. Lucia"
                                                  },
                                                  {
                                                    "id": "c25000100015",
                                                    "label": "St. Vincent and the Grenadines"
                                                  },
                                                  {
                                                    "id": "c25000100021",
                                                    "label": "Suriname"
                                                  },
                                                  {
                                                    "id": "c25000100024",
                                                    "label": "Trinidad and Tobago"
                                                  }
                                                ]
                                              },
                                              {
                                                "id": "c00000000009",
                                                "label": "Argentina"
                                              },
                                              {
                                                "id": "c10000000011",
                                                "label": "Bolivia"
                                              },
                                              {
                                                "id": "c10000001027",
                                                "label": "Chile"
                                              },
                                              {
                                                "id": "c00000000033",
                                                "label": "Colombia"
                                              },
                                              {
                                                "id": "c10000000013",
                                                "label": "Ecuador"
                                              },
                                              {
                                                "id": "c10000000020",
                                                "label": "Paraguay"
                                              },
                                              {
                                                "id": "c10000000012",
                                                "label": "Peru"
                                              },
                                              {
                                                "id": "c00000000073",
                                                "label": "Uruguay"
                                              },
                                              {
                                                "id": "c00000000075",
                                                "label": "Venezuela"
                                              }
                                            ]
                                          },
                                          {
                                            "id": "c00000000013",
                                            "label": "Brazil"
                                          }
                                        ]
                                      },
                                      {
                                        "id": "c00000000063",
                                        "label": "Sub-Saharan Africa",
                                        "children": [
                                          {
                                            "id": "c25000100032",
                                            "label": "Other Sub-Saharan countries",
                                            "children": [
                                              {
                                                "id": "c10000001015",
                                                "label": "Benin"
                                              },
                                              {
                                                "id": "c10000001018",
                                                "label": "Botswana"
                                              },
                                              {
                                                "id": "c10000000029",
                                                "label": "Burkina Faso"
                                              },
                                              {
                                                "id": "c10000001020",
                                                "label": "Burundi"
                                              },
                                              {
                                                "id": "c10000001022",
                                                "label": "Cameroon"
                                              },
                                              {
                                                "id": "c10000001023",
                                                "label": "Cape Verde"
                                              },
                                              {
                                                "id": "c10000001025",
                                                "label": "Central African Repulic"
                                              },
                                              {
                                                "id": "c10000001026",
                                                "label": "Chad"
                                              },
                                              {
                                                "id": "c10000001028",
                                                "label": "Comoros"
                                              },
                                              {
                                                "id": "c10000001029",
                                                "label": "Congo D.R."
                                              },
                                              {
                                                "id": "c10000001030",
                                                "label": "Djibouti"
                                              },
                                              {
                                                "id": "c10000001031",
                                                "label": "Eritrea"
                                              },
                                              {
                                                "id": "c10000001075",
                                                "label": "Eswatini"
                                              },
                                              {
                                                "id": "c10000001035",
                                                "label": "Gabon"
                                              },
                                              {
                                                "id": "c10000001036",
                                                "label": "Gambia"
                                              },
                                              {
                                                "id": "c10000001040",
                                                "label": "Guinea"
                                              },
                                              {
                                                "id": "c10000001049",
                                                "label": "Lesotho"
                                              },
                                              {
                                                "id": "c10000001051",
                                                "label": "Liberia"
                                              },
                                              {
                                                "id": "c10000000030",
                                                "label": "Madagascar"
                                              },
                                              {
                                                "id": "c10000001056",
                                                "label": "Malawi"
                                              },
                                              {
                                                "id": "c10000001058",
                                                "label": "Mali"
                                              },
                                              {
                                                "id": "c10000001060",
                                                "label": "Mozambique"
                                              },
                                              {
                                                "id": "c10000001063",
                                                "label": "Namibia"
                                              },
                                              {
                                                "id": "c10000001066",
                                                "label": "Niger"
                                              },
                                              {
                                                "id": "c10000001070",
                                                "label": "Rwanda"
                                              },
                                              {
                                                "id": "c10000001071",
                                                "label": "Saychelles"
                                              },
                                              {
                                                "id": "c25000100017",
                                                "label": "Sierra Leone"
                                              },
                                              {
                                                "id": "c10000001073",
                                                "label": "Somalia"
                                              },
                                              {
                                                "id": "c25000100019",
                                                "label": "South Sudan"
                                              },
                                              {
                                                "id": "c10000001074",
                                                "label": "Sudan"
                                              },
                                              {
                                                "id": "c10000001078",
                                                "label": "Togo"
                                              },
                                              {
                                                "id": "c10000001089",
                                                "label": "Zimbabwe"
                                              }
                                            ]
                                          },
                                          {
                                            "id": "c10000001005",
                                            "label": "Angola"
                                          },
                                          {
                                            "id": "c10000001032",
                                            "label": "Ethiopia"
                                          },
                                          {
                                            "id": "c10000001038",
                                            "label": "Ghana"
                                          },
                                          {
                                            "id": "c25000100005",
                                            "label": "Ivory Coast"
                                          },
                                          {
                                            "id": "c10000001045",
                                            "label": "Kenya"
                                          },
                                          {
                                            "id": "c10000001067",
                                            "label": "Nigeria"
                                          },
                                          {
                                            "id": "c10000001072",
                                            "label": "Senegal"
                                          },
                                          {
                                            "id": "c25000100034",
                                            "label": "South Africa"
                                          },
                                          {
                                            "id": "c10000001076",
                                            "label": "Tanzania"
                                          },
                                          {
                                            "id": "c10000001081",
                                            "label": "Uganda"
                                          },
                                          {
                                            "id": "c10000001088",
                                            "label": "Zambia"
                                          }
                                        ]
                                      },
                                      {
                                        "id": "c10000000010",
                                        "label": "USMCA",
                                        "children": [
                                          {
                                            "id": "c00000000031",
                                            "label": "Canada"
                                          },
                                          {
                                            "id": "c00000000042",
                                            "label": "Mexico"
                                          },
                                          {
                                            "id": "c00000000074",
                                            "label": "USA"
                                          }
                                        ]
                                      }
                                    ]
                                    ;